"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _TagAuthorize = _interopRequireDefault(require("@rsuite/icon-font/lib/application/TagAuthorize"));

// Generated by script, don't edit it please.
var TagAuthorize = (0, _createSvgIcon["default"])({
  as: _TagAuthorize["default"],
  ariaLabel: 'tag authorize',
  category: 'application',
  displayName: 'TagAuthorize'
});
var _default = TagAuthorize;
exports["default"] = _default;
module.exports = exports.default;